import React from 'react';
import { styled, Button } from '@goodrx/matisse';

import { DefaultMessage, MessageProps } from 'app/components/widgets/chat/message-types';
import { MessageTypes } from '@goodrx/heydoctor-core';
import { useAppContext } from 'app/config/AppContext';

const MessageAction = styled.div`
  padding: ${(p) => p.theme.space[1]}px;
  margin-top: 12px;
`;

const ActionButton = styled(Button).attrs((p) => ({
  variant: `${p.isGoldClient ? 'secondary' : 'primary'}`,
}))`
  border-color: ${(p) => (p.isGoldClient ? p.theme?.colors.primaryLight : 'white')};
  color: ${(p) => (p.isGoldClient ? p.theme?.colors.primaryLight : 'white')};
  font-family: ${(p) => p.baseFontFamily || 'Avenir, sans-serif'};
  text-transform: ${(p) => (p.isGoldClient ? 'none' : 'capitalize')};
`;

const PRESCRIPTION_GOLD = 'prescription_gold';
// Future change will update/extend the type definition to natively support this copy change
const MessageTypeDisplayText = {
  [MessageTypes.RETAKE_PHOTOS]: 'Retake Photos',
  [MessageTypes.PRESCRIPTION]: 'Get Prescription',
  [MessageTypes.PHONE_CALL_BACK]: 'Continue',
  [PRESCRIPTION_GOLD]: 'Choose your pharmacy',
};

export interface ActionableMessageProps extends MessageProps {
  onActionClick: () => void;
  disabled?: boolean;
}

export const ActionableMessage: React.FC<ActionableMessageProps> = ({
  message,
  onActionClick,
  messageRef,
  disabled,
}) => {
  const {
    isGold,
    config: {
      Theme: {
        typography: { baseFontFamily },
      },
    },
  } = useAppContext();
  return (
    <DefaultMessage message={message} messageRef={messageRef} fromCurrentUser={false}>
      <MessageAction>
        <ActionButton
          data-qa="message_action_btn"
          block
          baseFontFamily={baseFontFamily}
          onClick={onActionClick}
          disabled={disabled}
          isGoldClient={isGold}>
          {isGold && message.type === MessageTypes.PRESCRIPTION
            ? MessageTypeDisplayText[PRESCRIPTION_GOLD]
            : MessageTypeDisplayText[message.type]}
        </ActionButton>
      </MessageAction>
    </DefaultMessage>
  );
};
